import { defineComponent as B, useSlots as N, useCssModule as T, ref as u, watch as V, onMounted as w, openBlock as E, createElementBlock as P, normalizeClass as i, unref as r, createElementVNode as f, renderSlot as a, createVNode as m, withCtx as k, createTextVNode as A, toDisplayString as x, createCommentVNode as z } from "vue";
import M from "tabbable";
import D from "../icon/comps/x-sm.vue.mjs";
import H from "../button/CdrButton.vue.mjs";
import L from "../popup/CdrPopup.vue.mjs";
import O from "../../utils/propValidator.mjs";
import j from "../../utils/mapClasses.mjs";
const U = /* @__PURE__ */ B({
  name: "CdrPopover",
  __name: "CdrPopover",
  props: {
    /**
     * Sets the position where the popover will render relative to the trigger element.
     * @demoSelectMultiple false
     * @values top, bottom, left, right
     */
    position: {
      type: String,
      required: !1,
      default: "top",
      validator: (t) => O(t, ["top", "bottom", "left", "right"])
    },
    /**
     * If set to `true`, popover will attempt to dynamically set it's position to
     * ensure it renders within the visible browser window.
     * If `false` the popover will always render in the provided `position`.
     */
    autoPosition: {
      type: Boolean,
      required: !1,
      default: !0
    },
    /** Sets the title for the popover content. Can also be provided via the `title` slot. */
    label: {
      type: String,
      required: !1
    },
    /** ID for the popover element, required for accessibility */
    id: {
      type: String,
      required: !0
    },
    /** Add custom class to the popover content wrapper. Allows for overriding size, styling, etc. */
    contentClass: {
      type: String,
      required: !1
    },
    /**
     * Used to programmatically control the popover state. Does not need to be set if you are using the `trigger` slot.
     * @demoIgnore true
     */
    open: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  emits: {
    /** Emits when popover is opened */
    opened: null,
    /** Emits when popover is closed */
    closed: null
  },
  setup(t, {
    emit: S
  }) {
    const n = t, v = S, g = N(), l = T(), s = u(!1);
    let c;
    const d = u(null), C = u(null), $ = g.trigger, q = g.title || n.label, b = (e) => {
      if (s.value === !0)
        return;
      const {
        activeElement: o
      } = document;
      c = o, s.value = !0, v("opened", e), setTimeout(() => {
        var h;
        const y = M((h = C.value) == null ? void 0 : h.$el);
        y[0] && y[0].focus();
      }, 50);
    }, p = (e) => {
      s.value = !1, v("closed", e), c && c.focus();
    }, _ = () => {
      var o;
      const e = (o = d.value) == null ? void 0 : o.children[0];
      e && e.addEventListener("click", b);
    };
    return V(() => n.open, () => {
      n.open ? b() : p();
    }), w(() => {
      var o;
      _();
      const e = (o = d.value) == null ? void 0 : o.children[0];
      e && (e.setAttribute("aria-controls", n.id), e.setAttribute("aria-haspopup", "dialog"));
    }), (e, o) => (E(), P("div", {
      class: i(r(j)(r(l), "cdr-popover--wrapper", r($) ? "cdr-popover--position" : ""))
    }, [f("div", {
      ref_key: "triggerEl",
      ref: d
    }, [a(e.$slots, "trigger")], 512), m(L, {
      role: "dialog",
      ref_key: "popupEl",
      ref: C,
      onClosed: p,
      position: t.position,
      "auto-position": t.autoPosition,
      opened: s.value,
      "aria-expanded": `${s.value}`,
      id: t.id,
      "content-class": t.contentClass
    }, {
      default: k(() => [f("div", {
        class: i(r(l)["cdr-popover__container"])
      }, [f("div", {
        class: i(r(l)["cdr-popover__content"])
      }, [r(q) ? (E(), P("div", {
        key: 0,
        class: i(r(l)["cdr-popover__title"])
      }, [a(e.$slots, "title", {}, () => [A(x(t.label), 1)])], 2)) : z("", !0), a(e.$slots, "default")], 2), m(H, {
        class: i(r(l)["cdr-popover__close-button"]),
        "icon-only": "",
        onClick: p,
        "aria-label": "Close",
        size: "small"
      }, {
        default: k(() => [a(e.$slots, "icon", {}, () => [m(D, {
          "inherit-color": ""
        })])]),
        _: 3
      }, 8, ["class"])], 2)]),
      _: 3
    }, 8, ["position", "auto-position", "opened", "aria-expanded", "id", "content-class"])], 2));
  }
});
export {
  U as default
};
